import FilterContainer from '@/components/FilterContainer/FilterContainer';

export default FilterContainer;
